import { makeStyles } from "@material-ui/core";

type ProviderIconProps = {
  src?: string;
};

const useStyles = makeStyles(({ spacing, palette }) => ({
  currentProvider: {
    visibility: "visible !important" as "visible",
  },
  menuCheckmark: {
    height: 16,
    width: 16,
    visibility: "hidden",
  },
  menuItem: {
    fontSize: 18,
    "&:not(:first-child)": {
      borderTop: `solid 1px ${palette.grey[200]}`,
    },
    padding: spacing(2),
  },
  providerIcon: {
    backgroundColor: palette.primary.light,
    backgroundImage: ({ src }: ProviderIconProps) => `url(${src})`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "contain",
    backgroundPosition: "center",
    flex: "0 0 24px",
    height: 24,
    width: 24,
    borderRadius: 999,
  },
}));

export default useStyles;
